import { useState } from "react";

import ProductCard from "~/components/common/PricingCard/PricingCard";
import {
  IntervalPrice,
  type ProductSubscription,
} from "~/modules/subscription/type";

interface PricingProps {
  products: ProductSubscription[];
  showRecommended?: boolean;
  defaultDisplayQuarterly?: boolean;
  activePlanId?: string;
  canSubscribe?: boolean;
}

const Pricing = ({
  products,
  showRecommended,
  defaultDisplayQuarterly = true,
  activePlanId,
  canSubscribe = false,
}: PricingProps) => {
  const [toggle, setToggle] = useState(defaultDisplayQuarterly);
  return (
    <>
      <div className="mb-[25px] flex items-center justify-center md:mb-[45px]">
        <span
          className={`w-[52px] text-sm capitalize ${
            !toggle && "font-semibold"
          }`}
        >
          {IntervalPrice.MONTHLY}
        </span>
        <label className="relative mx-[15px] inline-flex cursor-pointer items-center">
          <input
            type="checkbox"
            value=""
            className="peer sr-only"
            onChange={() => setToggle(!toggle)}
            {...{ checked: toggle }}
          />
          <div className="peer h-[25px] w-[49px] rounded-full border bg-white after:absolute after:left-[5px] after:top-[5px] after:size-[15px] after:rounded-full after:border after:bg-purple after:transition-all after:content-[''] peer-checked:after:translate-x-[24px] peer-checked:after:border-white peer-focus:outline-none peer-focus:ring-1"></div>
        </label>
        <span
          className={`w-[62px] text-sm capitalize ${toggle && "font-semibold"}`}
        >
          {IntervalPrice.QUARTERLY}
        </span>
        <span className="ml-[8px] rounded-full border border-purple px-[5px] py-[2px] text-xs uppercase text-purple">
          Over 15% off
        </span>
      </div>
      <div className="mb-[55px] space-y-8 sm:gap-6 lg:grid lg:grid-cols-3 lg:gap-[20px] lg:space-y-0">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            intervalToggle={
              toggle ? IntervalPrice.QUARTERLY : IntervalPrice.MONTHLY
            }
            showRecommended={showRecommended}
            activePlanId={activePlanId}
            canSubscribe={canSubscribe}
          />
        ))}
      </div>
    </>
  );
};

export default Pricing;
